export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  image: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
  featured: boolean;
}

export interface Category {
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    name: '赛事预测',
    slug: 'saishi-yuce',
    description: '专业赛事分析与精准预测，助您把握每一场比赛的胜负走向',
    icon: 'ri-football-line',
    count: 28,
  },
  {
    name: '体育资讯',
    slug: 'tiyu-zixun',
    description: '最新体育动态、赛事报道与深度分析，第一时间掌握体坛风云',
    icon: 'ri-newspaper-line',
    count: 45,
  },
  {
    name: '运动健康',
    slug: 'yundong-jiankang',
    description: '科学运动指导、健康生活建议，让运动成为生活的一部分',
    icon: 'ri-heart-pulse-line',
    count: 32,
  },
  {
    name: '竞技分析',
    slug: 'jingji-fenxi',
    description: '深度竞技数据分析与战术解读，专业视角看比赛',
    icon: 'ri-bar-chart-box-line',
    count: 19,
  },
  {
    name: '电竞专区',
    slug: 'dianjing-zhuanqu',
    description: '电子竞技赛事报道、战队动态与行业观察',
    icon: 'ri-gamepad-line',
    count: 24,
  },
  {
    name: '篮球世界',
    slug: 'lanqiu-shijie',
    description: 'NBA、CBA等篮球赛事全方位报道与深度解析',
    icon: 'ri-basketball-line',
    count: 36,
  },
];

export const articles: Article[] = [
  {
    id: '1',
    slug: '2026-world-cup-preview',
    title: '2026世界杯前瞻：各队实力分析与夺冠热门预测',
    excerpt: '随着2026年世界杯临近，各支参赛队伍已陆续公布大名单。本文将从阵容深度、近期状态、战术体系等多维度深入分析各队竞争力，为您揭晓本届世界杯的夺冠热门。',
    content: `<p>随着2026年世界杯的脚步日益临近，全球足球迷的目光再次聚焦于这项四年一度的顶级赛事。本届世界杯将在北美三国联合举办，参赛队伍扩军至48支，竞争格局将更加复杂多变。</p>
    <h2>传统强队：谁将问鼎？</h2>
    <p>法国队作为卫冕冠军，拥有姆巴佩、楚阿梅尼等世界级球星，阵容深度令人艳羡。球队在德尚的带领下形成了成熟的战术体系，攻防两端均展现出顶级水平。然而，卫冕冠军的魔咒始终是悬在法国队头上的一把利剑。</p>
    <p>阿根廷队在2022年夺冠后，球队新老交替工作稳步推进。梅西虽已进入职业生涯晚期，但他在国家队的领袖作用无人替代。新一代球员如恩佐·费尔南德斯、阿尔瓦雷斯等人的成长，让阿根廷队依然保持着强大的竞争力。</p>
    <p>巴西队永远是世界杯的热门。内马尔、维尼修斯、罗德里戈组成的攻击线堪称豪华，球队在进攻端的创造力令人胆寒。但防守端的稳定性依然是巴西队需要解决的关键问题。</p>
    <h2>新兴势力：黑马可期</h2>
    <p>摩洛哥队在2022年世界杯上的惊艳表现让世界记住了这支非洲劲旅。球队的整体防守体系和对比赛节奏的把控能力已达到世界级水准。本届世界杯，摩洛哥有望继续创造历史。</p>
    <p>日本队的技战术水平近年来突飞猛进，大量球员在欧洲顶级联赛效力，整体实力已跻身世界一流行列。三笘薰、久保建英等球员的个人能力足以改变比赛走向。</p>
    <h2>预测结论</h2>
    <p>综合各队实力、赛程安排和分组情况，我们认为法国、阿根廷、巴西和英格兰构成了本届世界杯的第一梯队。而摩洛哥、日本、克罗地亚等队则有望成为搅局者。足球的魅力在于不可预测，让我们共同期待这场足球盛宴的到来。</p>`,
    category: '赛事预测',
    categorySlug: 'saishi-yuce',
    image: 'https://readdy.ai/api/search-image?query=Professional%20soccer%20stadium%20with%20dramatic%20stadium%20lights%20and%20green%20pitch%2C%20world%20cup%20atmosphere%2C%20wide%20angle%20aerial%20view%2C%20sports%20photography%20style%20with%20epic%20lighting%2C%20clean%20minimal%20background&width=1200&height=675&seq=world-cup-2026&orientation=landscape',
    author: '张教练',
    publishDate: '2026-08-01',
    readTime: '8分钟',
    tags: ['世界杯', '足球', '赛事预测', '法国队', '阿根廷队'],
    featured: true,
  },
  {
    id: '2',
    slug: 'nba-playoffs-2026-analysis',
    title: 'NBA季后赛深度解析：东西部格局剧变背后的战术革命',
    excerpt: '本赛季NBA季后赛呈现出前所未有的激烈态势。传统豪强遭遇挑战，新生代球星崭露头角。本文深入分析季后赛的战术演变与关键对决。',
    content: `<p>2026年NBA季后赛如火如荼地进行中，东西部格局正在经历一场前所未有的剧变。传统豪强遭遇严峻挑战，新生代球星的崛起让联盟版图悄然重塑。</p>
    <h2>东部战场：新旧势力的交锋</h2>
    <p>凯尔特人队延续了常规赛的统治力，塔图姆和布朗的双核驱动让球队在攻防两端都保持着极高水准。但步行者队的异军突起给东部格局带来了巨大变数，哈利伯顿的组织才华和球队的整体性令人印象深刻。</p>
    <p>雄鹿队在字母哥的带领下依然是不可忽视的力量，但球队外线投射的不稳定性成为隐患。热火队的铁血防守文化依然让任何对手都感到头疼。</p>
    <h2>西部战场：群雄逐鹿</h2>
    <p>掘金队作为卫冕冠军，约基奇的统治力依然是联盟顶级。但雷霆队的年轻风暴来势汹汹，亚历山大已成为MVP级别的球员，球队的深度和运动能力令人艳羡。</p>
    <p>独行侠队的东契奇继续书写着自己的传奇，但球队过度依赖单核的问题在季后赛被放大。森林狼队的双塔阵容在防守端展现出惊人威力。</p>
    <h2>战术革命：小球时代的终结？</h2>
    <p>值得关注的是，本赛季多支球队开始重新重视内线高度和低位进攻，这似乎预示着"小球时代"正在迎来新的变革。约基奇、恩比德等传统中锋的统治力证明，内线优势依然是赢得季后赛的关键因素。</p>`,
    category: '竞技分析',
    categorySlug: 'jingji-fenxi',
    image: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20court%20with%20dramatic%20lighting%20and%20action%20atmosphere%2C%20NBA%20playoff%20intensity%2C%20wide%20angle%20arena%20view%2C%20sports%20photography%20with%20clean%20background&width=1200&height=675&seq=nba-playoffs-2026&orientation=landscape',
    author: '李分析师',
    publishDate: '2026-08-03',
    readTime: '10分钟',
    tags: ['NBA', '篮球', '季后赛', '战术分析'],
    featured: true,
  },
  {
    id: '3',
    slug: 'running-training-guide',
    title: '科学跑步训练指南：从零基础到半马完赛的完整计划',
    excerpt: '跑步是最简单有效的运动方式之一。本文为跑步爱好者提供了一份从入门到进阶的完整训练计划，帮助您科学训练、远离伤病。',
    content: `<p>跑步被誉为"运动之王"，是门槛最低、效果最全面的有氧运动之一。无论是为了健康、减脂还是挑战自我，跑步都是绝佳的选择。然而，不科学的训练方式往往会导致伤病，让跑步热情戛然而止。</p>
    <h2>第一阶段：基础建立（第1-4周）</h2>
    <p>对于零基础的跑步者来说，最重要的不是速度和距离，而是建立运动习惯和正确的跑步姿态。建议采用"跑走结合"的方式开始训练：每次运动30分钟，其中跑步5分钟与快走3分钟交替进行。</p>
    <p>跑步姿态要点：保持身体略微前倾，步幅不宜过大，脚掌中部着地，双臂自然摆动。呼吸采用"两步一吸、两步一呼"的节奏。</p>
    <h2>第二阶段：耐力提升（第5-8周）</h2>
    <p>当身体逐渐适应跑步节奏后，可以开始增加跑步时间和距离。每周递增10%的训练量是公认的安全原则。此阶段应加入一次长距离慢跑，以建立有氧基础。</p>
    <h2>第三阶段：速度训练（第9-12周）</h2>
    <p>在具备一定耐力基础后，可以引入间歇跑和节奏跑等速度训练。间歇跑能有效提升最大摄氧量，节奏跑则帮助身体适应比赛配速。</p>
    <h2>营养与恢复</h2>
    <p>训练之余，营养补充和充分恢复同样重要。跑步后30分钟内补充碳水和蛋白质，保证充足的睡眠，定期进行拉伸和泡沫轴放松，都是避免伤病的关键。</p>`,
    category: '运动健康',
    categorySlug: 'yundong-jiankang',
    image: 'https://readdy.ai/api/search-image?query=Runner%20on%20scenic%20trail%20during%20golden%20hour%20sunrise%2C%20athletic%20lifestyle%20photography%2C%20clean%20natural%20background%20with%20soft%20warm%20lighting%2C%20fitness%20and%20wellness%20aesthetic&width=1200&height=675&seq=running-guide&orientation=landscape',
    author: '王教练',
    publishDate: '2026-08-05',
    readTime: '12分钟',
    tags: ['跑步', '训练计划', '运动健康', '马拉松'],
    featured: true,
  },
  {
    id: '4',
    slug: 'esports-worlds-2026',
    title: '2026英雄联盟全球总决赛：LPL赛区能否延续统治？',
    excerpt: '随着2026赛季的深入，各大赛区的格局逐渐清晰。LPL赛区在过去两个赛季展现了强大统治力，但LCK的复苏和欧美赛区的崛起让本届全球总决赛充满变数。',
    content: `<p>英雄联盟全球总决赛作为电竞界最受瞩目的赛事，每年都吸引着全球数亿玩家的目光。2026赛季的全球总决赛即将拉开帷幕，各大赛区的代表队已整装待发。</p>
    <h2>LPL：王朝的延续还是终结？</h2>
    <p>LPL赛区在过去两年中展现了令人窒息的统治力，包揽了多个国际赛事的冠军。JDG和BLG两支顶级战队的人员配置和战术体系已达到极致。但过多的内战消耗和版本变化的不确定性，为LPL的卫冕之路增添了变数。</p>
    <h2>LCK：王者归来</h2>
    <p>LCK赛区经过两年的蛰伏，本赛季展现出强劲的复苏势头。T1在Faker的带领下焕发新生，GEN.G的战术纪律性让人联想到巅峰时期的SSW。LCK的整体竞技水平正在快速追赶LPL。</p>
    <h2>版本解读</h2>
    <p>当前版本更强调上中野的联动和中期的资源控制，这对战术执行力和团队配合提出了更高要求。LPL擅长的小规模团战在本版本中依然具有优势，但LCK的运营能力同样不容忽视。</p>`,
    category: '电竞专区',
    categorySlug: 'dianjing-zhuanqu',
    image: 'https://readdy.ai/api/search-image?query=Esports%20arena%20with%20dramatic%20stage%20lighting%20and%20large%20LED%20screens%2C%20professional%20gaming%20tournament%20atmosphere%2C%20crowded%20stadium%20with%20fans%2C%20clean%20cyberpunk%20aesthetic&width=1200&height=675&seq=esports-worlds&orientation=landscape',
    author: '电竞观察员',
    publishDate: '2026-08-07',
    readTime: '7分钟',
    tags: ['英雄联盟', '电竞', 'LPL', '全球总决赛'],
    featured: true,
  },
  {
    id: '5',
    slug: 'premier-league-transfer-2026',
    title: '英超夏季转会窗口大盘点：亿元交易频现，格局重塑',
    excerpt: '2026年夏季转会窗落下帷幕，英超各队在转会市场上挥金如土。本文全面盘点各队引援情况，分析新赛季英超的竞争格局。',
    content: `<p>2026年夏季转会窗口在喧嚣中落下帷幕。英超球队再次展现了惊人的购买力，多笔亿元级别的交易刷新了转会纪录。新赛季的英超竞争格局正在被重塑。</p>
    <h2>重磅交易一览</h2>
    <p>曼城在失去德布劳内后进行了战略性补强，引进了两位世界级中场。阿森纳继续强化阵容深度，在锋线和后防线都进行了针对性引援。利物浦则完成了锋线的更新换代。</p>
    <h2>黑马球队的野心</h2>
    <p>纽卡斯尔联队凭借雄厚的资金实力，在转会市场上动作频频。球队的目标显然不止于欧战资格，挑战传统Big6的格局已箭在弦上。</p>
    <h2>新赛季格局预测</h2>
    <p>曼城依然是夺冠最大热门，但阿森纳和利物浦的差距正在缩小。纽卡斯尔和维拉有望成为搅局者，传统强队曼联和切尔西则需要尽快找到稳定性。</p>`,
    category: '体育资讯',
    categorySlug: 'tiyu-zixun',
    image: 'https://readdy.ai/api/search-image?query=Professional%20soccer%20stadium%20exterior%20with%20dramatic%20sky%2C%20premier%20league%20atmosphere%2C%20football%20club%20branding%2C%20clean%20minimal%20background%20with%20warm%20lighting&width=1200&height=675&seq=premier-league-transfer&orientation=landscape',
    author: '足球评论员',
    publishDate: '2026-08-06',
    readTime: '6分钟',
    tags: ['英超', '转会', '足球', '曼城', '阿森纳'],
    featured: false,
  },
  {
    id: '6',
    slug: 'sports-nutrition-guide',
    title: '运动营养全攻略：吃对食物，让训练事半功倍',
    excerpt: '合理的营养补充是运动表现提升的关键。本文详细介绍不同运动类型的营养需求，以及训练前后的饮食策略。',
    content: `<p>无论您是专业运动员还是健身爱好者，营养都是不容忽视的关键环节。合理的饮食策略不仅能提升运动表现，还能加速恢复、预防伤病。</p>
    <h2>三大宏量营养素的作用</h2>
    <p>碳水化合物是运动的主要能量来源，尤其在耐力运动中至关重要。蛋白质负责肌肉修复和生长，力量训练者需要重点补充。脂肪则提供持久能量，支持激素分泌。</p>
    <h2>训练前后的饮食策略</h2>
    <p>训练前2-3小时应摄入易消化的碳水化合物，为训练储备能量。训练后30-60分钟是营养补充的黄金窗口期，此时摄入碳水和蛋白质的比例应为3:1或4:1。</p>
    <h2>不同运动类型的营养方案</h2>
    <p>耐力运动需要更高的碳水摄入，力量训练则更注重蛋白质的补充时机。团队运动如足球、篮球则需要兼顾爆发力和耐力，营养方案更为复杂。</p>`,
    category: '运动健康',
    categorySlug: 'yundong-jiankang',
    image: 'https://readdy.ai/api/search-image?query=Healthy%20athletic%20meal%20prep%20with%20fresh%20ingredients%2C%20fitness%20nutrition%20lifestyle%2C%20clean%20minimal%20kitchen%20background%2C%20warm%20natural%20lighting%20food%20photography&width=1200&height=675&seq=sports-nutrition&orientation=landscape',
    author: '营养师小陈',
    publishDate: '2026-08-04',
    readTime: '9分钟',
    tags: ['运动营养', '饮食', '健身', '健康'],
    featured: false,
  },
  {
    id: '7',
    slug: 'table-tennis-world-championships',
    title: '世乒赛中国军团巡礼：新老交替中的王者之师',
    excerpt: '本届世乒赛中国队派出新老结合的阵容，既有经验丰富的老将压阵，也有朝气蓬勃的新星出战。本文全面分析中国队的参赛阵容与夺冠前景。',
    content: `<p>世界乒乓球锦标赛作为乒坛最高水平的赛事，每一届都吸引着全球球迷的关注。中国乒乓球队此次出征阵容既有经验丰富的老将，也有崭露头角的新星。</p>
    <h2>男队阵容分析</h2>
    <p>樊振东作为当今世界第一，技术全面且心理素质过硬，是男单夺冠的最大热门。王楚钦的进步有目共睹，其反手技术已达到世界顶级水准。新生代球员的崛起让中国男队的梯队建设更加完善。</p>
    <h2>女队阵容分析</h2>
    <p>孙颖莎在近两年的表现堪称完美，技术全面性和比赛阅读能力都达到了新的高度。王曼昱、陈梦等主力球员状态稳定，中国女队的整体优势依然明显。</p>
    <h2>主要对手分析</h2>
    <p>日本队的张本智和、伊藤美诚依然是中国队最强劲的对手。德国队的奥恰洛夫经验和实力兼具，韩国的年轻一代也在快速成长。但综合实力来看，中国队依然是夺冠的最大热门。</p>`,
    category: '体育资讯',
    categorySlug: 'tiyu-zixun',
    image: 'https://readdy.ai/api/search-image?query=Professional%20table%20tennis%20match%20with%20athlete%20in%20action%2C%20dramatic%20sports%20lighting%2C%20indoor%20arena%20atmosphere%2C%20clean%20minimal%20background%20with%20focused%20composition&width=1200&height=675&seq=table-tennis&orientation=landscape',
    author: '乒乓评论员',
    publishDate: '2026-08-02',
    readTime: '8分钟',
    tags: ['乒乓球', '世乒赛', '中国队', '樊振东', '孙颖莎'],
    featured: true,
  },
  {
    id: '8',
    slug: 'sports-psychology-mindset',
    title: '运动心理学：冠军心态是如何炼成的？',
    excerpt: '顶级运动员在关键时刻为什么能保持冷静？运动心理学揭示了冠军心态背后的科学原理和训练方法。',
    content: `<p>在竞技体育的世界里，当技术水平达到一定高度后，心理素质往往成为决定胜负的关键因素。为什么有些运动员在关键时刻总能发挥出色，而有些人却频频失手？</p>
    <h2>心理韧性的科学基础</h2>
    <p>心理韧性并非天赋，而是可以通过系统训练获得的能力。研究表明，顶级运动员在面对压力时会激活大脑中与情绪调节相关的区域，从而保持冷静和专注。</p>
    <h2>可视化训练法</h2>
    <p>许多精英运动员会在比赛前进行可视化训练——在脑海中反复模拟比赛场景和动作细节。这种训练方式能有效增强神经肌肉连接，提高实际比赛中的执行力。</p>
    <h2>呼吸与正念</h2>
    <p>简单的呼吸调节技术能在短时间内降低心率、缓解紧张。正念训练则帮助运动员专注于当下，不被过去的失误或未来的结果所干扰。</p>`,
    category: '运动健康',
    categorySlug: 'yundong-jiankang',
    image: 'https://readdy.ai/api/search-image?query=Athlete%20in%20deep%20focus%20and%20meditation%20before%20competition%2C%20dramatic%20lighting%2C%20emotional%20sports%20photography%2C%20clean%20dark%20background%20with%20inspirational%20mood&width=1200&height=675&seq=sports-psychology&orientation=landscape',
    author: '心理学博士刘',
    publishDate: '2026-08-01',
    readTime: '11分钟',
    tags: ['运动心理', '心理训练', '冠军心态', '正念'],
    featured: false,
  },
  {
    id: '9',
    slug: 'cba-new-season-preview',
    title: 'CBA新赛季前瞻：外援政策调整与本土球星崛起',
    excerpt: '新赛季CBA联赛即将拉开战幕，外援政策调整、多队换帅、本土新星涌现，联赛格局面临重大变化。',
    content: `<p>CBA新赛季即将开幕，多支球队在休赛期进行了大刀阔斧的调整。外援政策的变化、本土球星的成长，让新赛季的格局充满悬念。</p>
    <h2>外援政策调整的影响</h2>
    <p>新赛季外援出场时间限制进一步收紧，这意味着本土球员将承担更多的责任和出场时间。这对年轻球员的成长是重大利好，但也对各队的战术体系提出了新的挑战。</p>
    <h2>争冠格局分析</h2>
    <p>辽宁队作为卫冕冠军，核心阵容保持稳定，依然是夺冠最大热门。广东队在年轻化重建后展现出强劲活力。浙江稠州和广厦的本土阵容深度令人艳羡。</p>
    <h2>值得关注的新星</h2>
    <p>多位年轻球员在上赛季已经崭露头角，本赛季有望迎来质的飞跃。中国篮球的未来正在这些年轻人身上孕育。</p>`,
    category: '篮球世界',
    categorySlug: 'lanqiu-shijie',
    image: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20in%20Chinese%20arena%20with%20dramatic%20lighting%2C%20CBA%20league%20atmosphere%2C%20intense%20competition%20moment%2C%20clean%20minimal%20background&width=1200&height=675&seq=cba-new-season&orientation=landscape',
    author: '篮球评论员',
    publishDate: '2026-07-30',
    readTime: '7分钟',
    tags: ['CBA', '篮球', '中国篮球', '新赛季'],
    featured: false,
  },
  {
    id: '10',
    slug: 'fitness-trends-2026',
    title: '2026年健身趋势报告：科技赋能与个性化训练',
    excerpt: '从可穿戴设备到AI私教，科技正在深刻改变健身行业。本文盘点2026年最值得关注的健身趋势。',
    content: `<p>健身行业正在经历一场科技革命。从智能穿戴设备到AI驱动的个性化训练方案，科技正在让健身变得更加科学、高效和有趣。</p>
    <h2>AI私教：量身定制的训练方案</h2>
    <p>基于人工智能的虚拟私教正在迅速普及。通过分析用户的运动数据、身体指标和训练目标，AI能够生成高度个性化的训练计划，并根据训练反馈实时调整。</p>
    <h2>可穿戴设备的进化</h2>
    <p>最新一代的运动手表不仅能追踪心率和步数，还能监测血氧、睡眠质量、恢复状态等更全面的生理指标。这些数据为科学训练提供了强有力的支持。</p>
    <h2>居家健身2.0</h2>
    <p>后疫情时代，居家健身已从简单的线上课程进化为沉浸式的互动体验。VR健身、智能镜等设备让在家训练也能获得与健身房媲美的体验。</p>`,
    category: '运动健康',
    categorySlug: 'yundong-jiankang',
    image: 'https://readdy.ai/api/search-image?query=Modern%20smart%20gym%20with%20technology%20and%20fitness%20equipment%2C%20clean%20minimal%20interior%2C%20futuristic%20fitness%20lifestyle%2C%20warm%20ambient%20lighting%20with%20professional%20aesthetic&width=1200&height=675&seq=fitness-trends&orientation=landscape',
    author: '健身达人小周',
    publishDate: '2026-07-28',
    readTime: '6分钟',
    tags: ['健身', '科技', '可穿戴设备', 'AI'],
    featured: false,
  },
];

export function getFeaturedArticles(): Article[] {
  return articles.filter(a => a.featured);
}

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter(a => a.categorySlug === slug);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find(a => a.slug === slug);
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find(c => c.slug === slug);
}

export function getRelatedArticles(article: Article, limit: number = 3): Article[] {
  return articles
    .filter(a => a.id !== article.id && a.categorySlug === article.categorySlug)
    .slice(0, limit);
}